/**
 * Check if today is the user's birthday
 * Compares only day and month, ignoring the year
 * @param {Date|string} dateOfBirth - User's date of birth
 * @returns {boolean} - True if today is the user's birthday
 */
export const isBirthdayToday = (dateOfBirth) => {
    if (!dateOfBirth) {
        return false;
    }

    const today = new Date();
    const dob = new Date(dateOfBirth);

    // Compare only day and month
    const isBirthday = (
        today.getDate() === dob.getDate() &&
        today.getMonth() === dob.getMonth()
    );

    return isBirthday;
};

/**
 * Get user's age based on date of birth
 * @param {Date|string} dateOfBirth - User's date of birth
 * @returns {number} - User's age in years
 */
export const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return null;

    const today = new Date();
    const dob = new Date(dateOfBirth);
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age -= 1;
    }

    return age;
};